<template>
  <Layout>
    <div class="row client-detail align-items-center">
      <div class="col text-center">
        <h2 v-if="clients" class="text-white">Your Clients</h2>
        <router-link :to="{ name: 'dashboard', query: { go: 'addClient' }}">
          <button class="btn btn-outline-light m-3">
            Add Client
            <i class="fa fa-plus"></i>
          </button>
        </router-link>
        <button class="btn btn-outline-light" @click="reloadClients">
          <i class="fa fa-retweet"></i>
        </button>
      </div>
    </div>
    <div v-if="loadingClients" class="loadingDashboard">
      <loading></loading>
    </div>
    <div v-else class="row client-detail-container">
      <form class="form-inline w-100 d-flex justify-content-center" @submit.prevent="searchClients">
        <div class="input-group" style="max-width: 400px; width: 100%;">
          <input
            class="form-control searchInput"
            type="text"
            v-model="searchQuery"
            placeholder="Search"
            @keyup.enter="searchClients"
          />
          <div class="input-group-append">
            <button class="search-btn-rounded" type="submit">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="client-detail-container">
      <div class="main-masonry-container">
        <div v-for="client in resultQuery" :key="client.id" class="masonry-container masonry-grid-item">
          <div class="card text-center m3">
            <div class="card-body">
              <div v-if="client && client.thumbnailUrl" class="mb-4">
                <img class="rounded-circle avatar-sm" :src="`${client.thumbnailUrl}`" />
              </div>
              <div v-else class="avatar-sm mx-auto mb-4">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16"
                >{{ client.initials }}</span>
              </div>
              <h5 class="font-size-15">
                <a
                  href="javascript: void(0)"
                  class="text-dark"
                >{{ client.firstName + ' ' + client.lastName }}</a>
              </h5>
              <p v-if="client.comment" class="text-muted">
                <i class="bx bx-comment"></i>
                {{ client.comment }}
              </p>
              <div v-if="client.stats">
                <div class="item card-section" v-if="client.stats[0].pendingReviewTotal > 0 || client.stats[0].pendingShipmentTotal > 0">
                  <div class="card-section-container">
                    <div class="card-section-item text-center" @click="linkTo(client.id, '/account/sales/quotes')">
                      <h2 class="text-white">{{ client.stats[0].pendingReviewTotal }}</h2>
                      <p class="text-muted">Quotes to Review</p>
                    </div>
                    <div class="card-section-item text-center" @click="linkTo(client.id, '/account/ship-list')">
                      <h2 class="text-white">{{ client.stats[0].pendingShipmentTotal }}</h2>
                      <p class="text-muted">Stuff to Ship</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button class="btn btn-primary m-1 btn-sm" @click="viewClient(client.id)">Details</button>
                <button
                  @click="linkTo(client.id, '/account/dashboard')"
                  class="btn btn-primary m-1 btn-sm"
                >Buy</button>
                <router-link :to="{ name: 'quote-pickup', params: { id: client.id }}">
                  <button class="btn btn-primary m-1 btn-sm">Quotes</button>
                </router-link>
              </div>
            </div>
            <div class="card-footer bg-transparent border-top">
              <div class="contact-links d-flex font-size-20">
                <div class="flex-fill">
                  <a :href="'mailto:' + client.email">
                    <i class="bx bx-mail-send"></i>
                  </a>
                </div>
                <div class="flex-fill">
                  <a :href="'tel:' + client.phone">
                    <i class="bx bx-phone"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noOptions" v-if="resultQuery.length===0">Sorry, can't find anyone matching that.</div>
      <nav v-if="totalPages > 1" class="pagination-nav mt-4">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="goToPage(currentPage - 1)">Previous</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="goToPage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="goToPage(currentPage + 1)">Next</button>
          </li>
        </ul>
      </nav>
    </div>
    <b-modal
      id="client-modal"
      scrollable
      title-class="font-18"
      header-class="d-none"
      footer-class="d-none"
    >
      <client-detail :clientId="viewedClientId" :clientArray="clients"></client-detail>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from '../layouts/main'
import ClientDetail from '../../components/client-detail'
import Masonry from 'masonry-layout'
import api from '@/services/api'
import loading from '../../components/Loading'

export default {
  components: { ClientDetail, Layout, loading },
  data () {
    return {
      viewedClientId: '',
      filterPlaceholder: 'Search Clients',
      searchQuery: null,
      msnry: null,
      loadingClients: true,
      clients: [],
      currentPage: 1,
      totalPages: 1,
      perPage: 30
    }
  },
  methods: {
    getClientsData (page = 1, search = null) {
      const self = this
      self.loadingClients = true
      let url = `/api/stylist/clients?page=${page}`
      if (search && search.trim()) {
        url += `&search=${encodeURIComponent(search.trim())}`
      }
      api.get(url,
        {
          headers: {
            'Content-Type': 'application/x.fashionphile.v1+json, application/json'
          }
        }
      ).then(response => {
        const clientStats = response.data.data
        self.clients = clientStats.map(dataObject => {
          const client = { ...dataObject.attributes, id: Number(dataObject.id) }
          if (dataObject.attributes.stats) {
            client.stats = dataObject.attributes.stats[0]
          }
          return client
        })

        // Update store with basic client info (without stats) for other pages
        const basicClients = self.clients.map(client => {
          const { stats, ...basicClient } = client
          return basicClient
        })
        this.$store.dispatch('setClients', basicClients)

        if (response.data.meta && response.data.meta.pagination) {
          self.currentPage = response.data.meta.pagination.current_page
          self.totalPages = response.data.meta.pagination.total_pages
          self.perPage = response.data.meta.pagination.per_page
        }
        self.loadingClients = false
        self.msnryGrid()
      })
    },
    viewClient (clientId) {
      this.viewedClientId = clientId
      this.$bvModal.show('client-modal')
    },
    linkTo (clientId, url) {
      const data = {
        userId: clientId,
        url: process.env.VUE_APP_FASHIONPHILE_API_URL + url
      }
      this.$store.dispatch('authenticateAndRedirect', data)
    },
    msnryGrid () {
      this.$nextTick(() => {
        const grid = document.querySelector('.main-masonry-container')
        if (!grid) return
        if (this.msnry) {
          this.msnry.destroy()
        }
        this.msnry = new Masonry(grid, {
          itemSelector: '.masonry-grid-item'
        })
      })
    },
    searchClients () {
      this.getClientsData(1, this.searchQuery)
    },
    reloadClients () {
      this.searchQuery = null
      this.getClientsData(1)
    },
    goToPage (page) {
      this.clients = []
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page
      this.getClientsData(page, this.searchQuery)
    }
  },
  mounted () {
    // Fetch from API with server-side pagination
    console.log('[CLIENTS PAGE] Fetching clients from API (page 1)')
    this.getClientsData(1)
  },
  computed: {
    resultQuery () {
      return this.clients
    }
  },
  watch: {
    clients: {
      deep: true,
      handler () {
        this.msnryGrid()
      }
    },
    searchQuery () {
      this.msnryGrid()
    }
  }
}
</script>

<style type="text/css" scoped>
.client-detail .card {
  min-height: 1px !important;
}
.card-section-item {
  cursor: pointer;
}
.client-detail-container form {
  margin: 0 auto;
}
.search-btn-rounded {
  border-top-right-radius: var(--input-radius, 0.25rem);
  border-bottom-right-radius: var(--input-radius, 0.25rem);
  border: solid 1px;
  border-left: none;
  background: #EFEFEF !important;
  width: 50px;
}
.searchInput {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: none !important;
}
</style>
